import { render, staticRenderFns } from "./PdfLightbox.vue?vue&type=template&id=05e2cdb1&"
import script from "./PdfLightbox.vue?vue&type=script&lang=js&"
export * from "./PdfLightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports